import type { Types as SduiTypes } from '../types';
import type { OutTypes } from './schedules';

export default (
  lesson: SduiTypes.lesson
): OutTypes.event => {
  const start    = lesson.begins_at;
  const end      = lesson.ends_at;
  const duration = Math.floor((new Date(end).getTime() - new Date(start).getTime()) / 60000);  // in minutes

  return {
    ids:               lesson.id,
    course:            lesson.course_id,
    start:             lesson.begins_at,
    end:               lesson.ends_at,
    preferredDuration: duration,
    locations:         lesson.rooms?.map((to, i) => ({ locations: [to], groupIndex: i })),
    teachers:          lesson.teachers?.map(to => ({ to })),
    groups:            lesson.classes.map(to => ({ to })),
  };
};